import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/scope-of-work/$id')({
  component: () => null,
});
